
import './App.css';
import Router from './routes/Router';


function App() {

  return (
    <div>
      <Router />
      {/* <LoginPage /> */}
      {/* <Layout/> */}
    </div>
  );
}

export default App;
